import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home'));
const Poems = lazy(() => import('./pages/Poems'));   
const About = lazy(() => import('./pages/About'));
const Bookmarks = lazy(() => import('./pages/Bookmarks'));  
const LoginPage = lazy(() => import('./pages/LoginPage')); 
const Narrative = lazy(() => import('./pages/Narrative'));
const Details = lazy(() => import('./pages/Details'));
const MyInterests = lazy(() => import('./pages/MyInterests'));
function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <main className="flex-fill">
          <div className="container">
            <Suspense fallback={""}>
              <Routes>
                <Route path="/LoginPage" element={<LoginPage />} />
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} /> 
                <Route path="/poems" element={<Poems />} />
                <Route path="/narrative" element={<Narrative />} /> 
                <Route path="/about" element={<About />} />
                <Route path="/bookmarks" element={<Bookmarks />} /> 
                <Route path="/details/:id" element={<Details />} />
                  <Route path="/myInterests" element={<MyInterests />} />
              </Routes>
            </Suspense>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
